import { render, staticRenderFns } from "./TheReviewIcon.vue?vue&type=template&id=01042b61&"
import script from "./TheReviewIcon.vue?vue&type=script&lang=js&"
export * from "./TheReviewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports